import React from "react";
import { checkMaterial, returnKey } from "../../Helpers/checkLabel";
import { Chip } from "@material-ui/core";
import Translator from "Languages/Utility/Translator";

function TagFormatter(cell) {
  const { struct, size = "medium" } = cell;
  if (struct && typeof struct === "number") {
    const value = cell.struct === 1 ? "upvc" : "alu";
    return <Chip className={returnKey(value)} label={checkMaterial(value)} />;
  } else if (struct && typeof struct === "string") {
    return (
      <Chip
        className={`${returnKey(struct)} ${size}`}
        label={checkMaterial(struct)}
      />
    );
  } else if (typeof cell === "boolean") {
    return (
      <Chip
        className={!cell ? "success" : "danger"}
        label={!cell ? <Translator id="active" /> : <Translator id="disable" />}
      />
    );
  } else {
    return <Chip className={returnKey(cell)} label={checkMaterial(cell)} />;
  }
}

export default TagFormatter;
